import moment from 'moment';
import { useSelector } from 'react-redux';

import { selectBasket } from 'src/store/slices/basket-slice';
import { selectRoom, selectBuilding } from 'src/store/slices/booking-slice';
import {
    selectUserChoices,
    selectCreatedPaymentPlan,
    selectHasAdvancePayment,
} from 'src/store/slices/payment-plan-slice';
import { selectUserDetails } from 'src/store/slices/user-slice';

export const useTrackPurchaseEvent = () => {
    const roomData = useSelector(selectRoom);
    const userChoices = useSelector(selectUserChoices);
    const userData = useSelector(selectUserDetails);
    const buildingData = useSelector(selectBuilding);
    const createdPaymentPlan = useSelector(selectCreatedPaymentPlan);
    const hasAdvancePaymentFee = useSelector(selectHasAdvancePayment);
    const basket = useSelector(selectBasket);

    return () => {
        if (
            !basket ||
            !roomData ||
            !userChoices ||
            !userData ||
            !buildingData ||
            !createdPaymentPlan
        ) {
            return;
        }

        const category = [
            roomData.unit_type,
            basket?.products && basket.products[0]?.term,
            roomData.academic_year,
            basket.user?.university,
            basket.user?.nationality,
        ];

        const numberOfInstalments = hasAdvancePaymentFee
            ? createdPaymentPlan.paymentOptions.length - 1
            : createdPaymentPlan.paymentOptions.length;

        const now = moment();
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: now.unix(),
                value: createdPaymentPlan.totalRent,
                tax: 0,
                currency: roomData.currency,
                coupon: '',
                items: [
                    {
                        item_name: roomData.development_slug,
                        item_id: `${roomData.academic_year} ${roomData.room_code}`,
                        price: createdPaymentPlan.totalRent,
                        item_brand: buildingData.city_slug,
                        category: category.join('/'),
                    },
                ],
            },
            room_type: roomData.unit_type,
            floor: roomData.floor,
            view: roomData.view,
            number_of_students: userChoices.numberOfStudents,
            start_date: userChoices.term?.startDate,
            end_date: userChoices.term?.endDate,
            booking_length: userChoices.term?.name,
            year: now.year(),
            university: userData?.university,
            year_of_study: roomData.academic_year,
            nationality: userData?.nationality,
            pay_instalments: numberOfInstalments,
        });
    };
};
